var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"reset-password-type-container",attrs:{"align-v":"center","align-h":"start"}},[_c('b-link',{staticClass:"reset-password-type-link",attrs:{"variant":"primary"},on:{"click":_vm.resetPassword}},[_vm._v("\n    Réinitialiser le mot de passe\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8e9a070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/user/ResetPasswordType.vue
// module id = null
// module chunks = 